import { Avatar } from "@/components/ui";
import { FileText, Image } from "lucide-react";

export const getFileAvatar = (mime: string | undefined | null) => {
    if (mime?.split("/")[0] === "image") {
        return (
            <Avatar className="h-10 w-10 bg-red-600">
                <Image className="h-5 w-5 text-white" />
            </Avatar>
        );
    } else {
        return (
            <Avatar className="h-10 w-10 bg-blue-400">
                <FileText className="h-5 w-5 text-white" />
            </Avatar>
        );
    }
};
